// authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  user: null,
  theme: "light",
  inputData: null,
  token:'',
  reloadkycForm:(Math.random() + 1).toString(36).substring(7)
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginauth: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.token = action.payload.token
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.token = null;
    },
    moneyEntryData: (state, action) => {
      state.inputData = action.payload;
    },
    toggleTheme: (state) => {
      state.theme = state.theme === "light" ? "dark" : "light";
    },
    userDetails: (state, action) => {
      state.user = action.payload;
    },
    reloadKycFormUpdate:(state)=>{
     
      state.reloadkycForm = `${Date.now()}${(Math.random() + 1).toString(36).substring(7)}`    }
  },
});

export const { loginauth, logout, toggleTheme, userDetails, moneyEntryData,reloadKycFormUpdate } =
  authSlice.actions;
export default authSlice.reducer;
